import { bool, func, string } from 'prop-types';
import React from 'react';

import Star from 'shared/components/icon/Star';
import CheckboxInput from 'shared/components/input/CheckboxInput';

const Heading = ({
  title,
  subTitle,
  isJackpot = false,
  showSectionVisibilityButton = false,
  isSectionVisible,
  sectionVisibilityButtonLabel,
  onSectionVisibiltyChange,
}) => (
  <header className="heading">
    <div className="header-group">
      <h1>
        {title}
        {isJackpot && <Star className="yellow" />}
      </h1>
      {subTitle && <h2>{subTitle}</h2>}
    </div>
    {showSectionVisibilityButton && (
      <div className="checkbox-column">
        <div className="checkbox-wrapper">
          <CheckboxInput
            labelText={sectionVisibilityButtonLabel}
            checked={isSectionVisible}
            onChange={onSectionVisibiltyChange}
          />
        </div>
      </div>
    )}
  </header>
);

Heading.propTypes = {
  title: string.isRequired,
  subTitle: string,
  isJackpot: bool,
  showSectionVisibilityButton: bool,
  isSectionVisible: bool,
  sectionVisibilityButtonLabel: string,
  onSectionVisibiltyChange: func,
};

export default Heading;
